<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-08-18 19:53:04
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="content">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick1">
      <el-tab-pane label="经销商" name="first">
        <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
          <el-form-item label="创建时间:" style="text-align: center">
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="开始时间"
                v-model="form1.start_time"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="结束时间"
                v-model="form1.end_time"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="发货人信息:">
            <el-input v-model="form1.from_keyword" clearable placeholder="发货人/发货人编号"></el-input>
          </el-form-item>
          <el-form-item label="收货人信息:">
            <el-input v-model="form1.to_keyword" clearable placeholder="收货人/收货人编号"></el-input>
          </el-form-item>
          <el-form-item label="产品名称:">
            <el-input v-model="form1.product_name" clearable placeholder="产品名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getOutDealerData(pageNo1 = 1)">搜索</el-button>
            <el-button @click="outDealerExport()">导出</el-button>
          </el-form-item>
        </el-form>
        <!--表格-->
        <el-table
          ref="multipleTable"
          :data="tableData1"
          v-loading="loading"
          border
          stripe
          style="width: 100%;margin-top: 20px"
        >
          <el-table-column prop="stock_out_sn" label="出库单号">
          </el-table-column>
          <el-table-column
            prop="product_name"
            label="产品名称"
            show-overflow-tooltip
          >
            <template #default="{ row }">
                {{ row.product_name }}<br>{{ row.product_sn }}
            </template>
          </el-table-column>
          <el-table-column
            prop="from_name"
            label="发货经销商"
            show-overflow-tooltip
          >
          <template #default="{ row }">
                {{ row.from_name }}<br>{{ row.from_mobile }}
            </template>
          </el-table-column>
          <el-table-column
            prop="to_name"
            label="收货人名称"
            show-overflow-tooltip
          >
           <template #default="{ row }">
                {{ row.to_name }}<br>{{ row.to_sn }}
            </template>
          </el-table-column>
          <el-table-column
            prop="real_stock_out_num"
            label="出库数量"
            show-overflow-tooltip
          >
          </el-table-column>
          </el-table-column>
          <el-table-column
            prop="stock_out_time"
            label="创建时间"
            show-overflow-tooltip
          >
          </el-table-column>

          <!-- <el-table-column prop="" label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="instockDetail(scope.row)"
                >明细</el-button
              >
            </template>
          </el-table-column> -->
        </el-table>
        <!--分页-->
        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="pageNo1"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize1"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize1"
        >
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="门店" name="second">
         <el-form ref="form2" :model="form2" label-width="120px" :inline="true">
          <el-form-item label="创建时间:" style="text-align: center">
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="开始时间"
                v-model="form2.start_time"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="结束时间"
                v-model="form2.end_time"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="发货人信息:">
            <el-input v-model="form2.from_keyword" clearable placeholder="发货人/发货人编号"></el-input>
          </el-form-item>
          <el-form-item label="收货人信息:">
            <el-input v-model="form2.to_keyword" clearable placeholder="收货人/收货人编号"></el-input>
          </el-form-item>
          <el-form-item label="产品名称:">
            <el-input v-model="form2.product_name" clearable placeholder="产品名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getOutShopsData(pageNo2 = 1)">搜索</el-button>
            <el-button @click="outShopsExport()">导出</el-button>
          </el-form-item>
        </el-form>
        <!--表格-->
        <el-table
          ref="multipleTable"
          :data="tableData2"
          v-loading="loading"
          border
          stripe
          style="width: 100%;margin-top: 20px"
        >
          <el-table-column prop="stock_out_sn" label="出库单号">
          </el-table-column>
          <el-table-column
            prop="product_name"
            label="产品名称"
            show-overflow-tooltip
          >
            <template #default="{ row }">
                {{ row.product_name }}<br>{{ row.product_sn }}
            </template>
          </el-table-column>
          <el-table-column
            prop="from_name"
            label="发货经销商"
            show-overflow-tooltip
          >
          <template #default="{ row }">
                {{ row.from_name }}<br>{{ row.from_mobile }}
            </template>
          </el-table-column>
          <el-table-column
            prop="to_name"
            label="收货人名称"
            show-overflow-tooltip
          >
           <template #default="{ row }">
                {{ row.to_name }}<br>{{ row.to_sn }}
            </template>
          </el-table-column>
          <el-table-column
            prop="real_stock_out_num"
            label="出库数量"
            show-overflow-tooltip
          >
          </el-table-column>
          </el-table-column>
          <el-table-column
            prop="stock_out_time"
            label="创建时间"
            show-overflow-tooltip
          >
          </el-table-column>

          <!-- <el-table-column prop="" label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="instockDetail(scope.row)"
                >明细</el-button
              >
            </template>
          </el-table-column> -->
        </el-table>
        <!--分页-->
        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="pageNo2"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize2"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize2"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import selectRole from "../../common/selectRole";

export default {
  name: "base-count",
  data() {
    return {
      loading: false,
      activeName: "first",
      form1: {
        start_time: "",
        end_time: "",
        from_keyword: "",
        to_keyword: "",
        product_name: "",
  
      },
      form2: {
        start_time: "",
        end_time: "",
        from_keyword: "",
        to_keyword: "",
        product_name: "",
      },
      tableData1: [],
      tableData2: [],
      //分页
      pageNo1: 1,
      pageSize1: 10,
      totalSize1: 0,

      pageNo2: 1,
      pageSize2: 10,
      totalSize2: 0,
    };
  },
  methods: {
    getLastMonth() {
      var now = new Date();
      var year = now.getFullYear(); //getYear()+1900=getFullYear()
      var month = now.getMonth() + 1; //0-11表示1-12月
      var day = now.getDate();
      var dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }

      dateObj.now = year + "-" + month + "-" + day;

      if (parseInt(month) == 1) {
        //如果是1月份，则取上一年的12月份
        dateObj.last = parseInt(year) - 1 + "-12-" + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 1, 0).getDate(); //上月总天数
      if (preSize < parseInt(day)) {
        //上月总天数<本月日期，比如3月的30日，在2月中没有30
        dateObj.last = year + "-" + month + "-01";
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + "-0" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      } else {
        dateObj.last = year + "-" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      }
    },
    //渠道出库单（门店）
    getOutShopsData() {
      let beginstr = "",
        endstr = "";
      if (this.form2.start_time) {
        beginstr = this.moment(this.form2.start_time).format("YYYY-MM-DD");
      }
      if (this.form2.end_time) {
        endstr = this.moment(this.form2.end_time).format("YYYY-MM-DD");
      }
      this.loading = true;
      this.$get("logistics", "/channel.shops.outwarehouses", {
        lang: "",
        start_time: beginstr,
        end_time: endstr,
        from_keyword: this.form2.from_keyword,
        to_keyword: this.form2.to_keyword,
        product_name: this.form2.product_name,
        per_page: this.pageSize2,
        page: this.pageNo2,
      })
        .then((res) => {
          this.loading = false;
          this.tableData2 = res.data;
          this.totalSize2 = res.meta.total;
        })
        .catch(function(error) {
          this.loading = false;
          console.log(error);
        });
    },
    //渠道出库单（门店）导出
    outShopsExport() {
      let beginstr = "",
        endstr = "";
      if (this.form2.start_time) {
        beginstr = this.moment(this.form2.start_time).format("YYYY-MM-DD");
      }
      if (this.form2.end_time) {
        endstr = this.moment(this.form2.end_time).format("YYYY-MM-DD");
      }
      let url = "",
        access_tokens = localStorage.getItem("access_tokens");

      window.open(
        this.$Base_Export +
          "/channel.shops.outwarehouses.export?start_time=" +
          beginstr +
          "&end_time=" +
          endstr +
          "&is_export=1" +
          "&from_keyword=" +
          this.form2.from_keyword +
          "&to_keyword=" +
          this.form2.to_keyword +
          "&product_name=" +
          this.form2.product_name +
          "&lang=" +
          "" +
          "&signature=" +
          this.$md5(access_tokens)
      );
    },
    //渠道出库单（门店）
    getOutDealerData() {
      let beginstr = "",
        endstr = "";
      if (this.form1.start_time) {
        beginstr = this.moment(this.form1.start_time).format("YYYY-MM-DD");
      }
      if (this.form1.end_time) {
        endstr = this.moment(this.form1.end_time).format("YYYY-MM-DD");
      }
      this.loading = true;
      this.$get("logistics", "/channel.dealer.outwarehouses", {
        lang: "",
        start_time: beginstr,
        end_time: endstr,
        from_keyword: this.form1.from_keyword,
        to_keyword: this.form1.to_keyword,
        product_name: this.form1.product_name,
        per_page: this.pageSize1,
        page: this.pageNo1,
      })
        .then((res) => {
          this.loading = false;
          this.tableData1 = res.data;
          this.totalSize1 = res.meta.total;
        })
        .catch(function(error) {
          this.loading = false;
          console.log(error);
        });
    },
    //渠道出库单（门店）导出
    outDealerExport() {
      let beginstr = "",
        endstr = "";
      if (this.form1.start_time) {
        beginstr = this.moment(this.form1.start_time).format("YYYY-MM-DD");
      }
      if (this.form1.end_time) {
        endstr = this.moment(this.form1.end_time).format("YYYY-MM-DD");
      }
      let url = "",
        access_tokens = localStorage.getItem("access_tokens");

      window.open(
        this.$Base_Export +
          "/channel.dealer.outwarehouses.export?start_time=" +
          beginstr +
          "&end_time=" +
          endstr +
          "&is_export=1" +
          "&from_keyword=" +
          this.form1.from_keyword +
          "&to_keyword=" +
          this.form1.to_keyword +
          "&product_name=" +
          this.form1.product_name +
          "&lang=" +
          "" +
          "&signature=" +
          this.$md5(access_tokens)
      );
    },
    handleClick1(tab, event) {
      //console.log(tab, event);
    },
    handleClick2(tab, event) {
      //console.log(tab, event);
    },

    /*分页*/
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.pageNo1 = 1;
      this.getOutDealerData();
    },
    handleCurrentChange1(val) {
      this.pageNo1 = val;
      this.getOutDealerData();
    },

    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.pageNo2 = 1;
      this.getOutShopsData();
    },
    handleCurrentChange2(val) {
      this.pageNo2 = val;
      this.getOutShopsData();
    },
  },
  created() {
    this.form1.start_time = this.getLastMonth().last;
    this.form1.end_time = this.getLastMonth().now;
    this.form2.start_time = this.getLastMonth().last;
    this.form2.end_time = this.getLastMonth().now;
   
    this.getOutShopsData();
    this.getOutDealerData();
  },
};
</script>
<style lang="scss" scoped></style>
